export const UPDATE_FILTERS = 'UPDATE_FILTERS'

/**
 * Update route filters state.
 * @param {Object} filters
 */
export const updateFilters = filters => ({
    type: UPDATE_FILTERS,
    filters,
})

export const RESET_FILTERS = 'RESET_FILTERS'

/**
 * Reset route filters state.
 */
export const resetFilters = () => ({
    type: RESET_FILTERS,
})

export const HIGHLIGHT_ROUTE = 'HIGHLIGHT_ROUTE'

/**
 * Highlight a route.
 * @param {number} routeId
 */
export const highlightRoute = routeId => ({
    type: HIGHLIGHT_ROUTE,
    routeId,
})

export const UNHIGHLIGHT_ROUTE = 'UNHIGHLIGHT_ROUTE'

/**
 * Drop the highlighted route.
 */
export const unhighlightRoute = () => ({
    type: UNHIGHLIGHT_ROUTE,
})

export const UPDATE_PRIMARY_FILTERS = 'UPDATE_PRIMARY_FILTERS'

/**
 * Update primary filters.
 * @param {import("./reducers/primaryFiltersReducer").PrimarySearchFiltersState} [changes] Changes to apply or nothing to reset
 */
export const updatePrimaryFilters = changes => ({
    type: UPDATE_PRIMARY_FILTERS,
    changes,
})

export const QUERY_ON_MAP_MOVE = 'QUERY_ON_MAP_MOVE'

/**
 * Trigger a search query because bounds changed and searching on map move is enabled.
 */
export const queryOnMapMove = () => ({
    type: QUERY_ON_MAP_MOVE,
})

export const ENABLE_QUERY_ON_FILTERS_CHANGE = 'ENABLE_QUERY_ON_FILTERS_CHANGE'

/**
 * Enable immediate queries on filters change.
 */
export const enableQueryOnFiltersChange = () => ({
    type: ENABLE_QUERY_ON_FILTERS_CHANGE,
})

export const DISABLE_QUERY_ON_FILTERS_CHANGE = 'DISABLE_QUERY_ON_FILTERS_CHANGE'

/**
 * Disable immediate queries on filters change.
 */
export const disableQueryOnFiltersChange = () => ({
    type: DISABLE_QUERY_ON_FILTERS_CHANGE,
})

export const TOGGLE_DEBUG_MODE = 'TOGGLE_DEBUG_MODE'

/**
 * Enable or disable debug mode.
 * @param {boolean} active Whether debug mode should be enabled
 */
export const toggleDebugMode = active => ({
    type: TOGGLE_DEBUG_MODE,
    active,
})

export const TOGGLE_MAP_VIEW = 'TOGGLE_MAP_VIEW'

/**
 * Enable or disable map view.
 * @param {boolean} active Whether the map view should be enabled
 */
export const toggleMapView = active => ({
    type: TOGGLE_MAP_VIEW,
    active,
})

export const INITIAL_BOUNDLESS_QUERY = 'INITIAL_BOUNDLESS_QUERY'

/**
 * Starts querying routes even without map bounds.
 */
export const initialBoundlessQuery = () => ({
    type: INITIAL_BOUNDLESS_QUERY,
})
